import React from 'react';
import { GoldButton } from './GoldButton';
import { motion } from 'framer-motion';
interface CurriculumSectionProps {
  onRegisterClick: () => void;
}
export function CurriculumSection({
  onRegisterClick
}: CurriculumSectionProps) {
  const cards = [{
    time: 'PART 1 - 30 MIN',
    title: 'THE $1M WAKE UP CALL',
    body: 'How one commercial deal can 10X residential deals with less time.'
  }, {
    time: 'PART 2 - 30 MIN',
    title: 'THE DEAL MACHINE',
    body: 'How to find Off-Market deals, without chasing after brokers.'
  }, {
    time: 'PART 3 - 30 MIN',
    title: 'THE PROFIT FORMULA',
    body: 'How to make a $100K–$250K profit before you ever close, without ownership.'
  }];
  return <section className="py-20 md:py-32 bg-brand-navy relative" data-id="element-14">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-15">
        {/* Header */}
        <div className="text-center mb-16 md:mb-24" data-id="element-16">
          <h2 className="font-display text-brand-gold uppercase tracking-widest text-sm md:text-base mb-4" data-id="element-17">
            What Happens In
          </h2>
          <h3 className="font-display text-white text-4xl md:text-6xl font-bold uppercase mb-6" data-id="element-18">
            The{' '}
            <span className="font-script text-brand-gold lowercase text-5xl md:text-7xl px-2" data-id="element-19">
              Fast Profit
            </span>{' '}
            Workshop
          </h3>
          <p className="font-display text-white uppercase tracking-[0.2em] text-sm md:text-lg" data-id="element-20">
            90 MINUTES · ONE SESSION · LIVE
          </p>
        </div>

        {/* Timeline Rail */}
        <div className="relative mb-12 hidden md:block" data-id="element-21">
          <div className="absolute top-1/2 left-0 w-full h-[2px] bg-brand-gold/30 -translate-y-1/2" data-id="element-22"></div>
          <div className="relative flex justify-between px-8" data-id="element-23">
            {['0 MIN', '30 MIN', '60 MIN', '90 MIN'].map((label, i) => <div key={label} className="flex flex-col items-center gap-4" data-id="element-24">
                <div className="w-4 h-4 rounded-full bg-brand-gold shadow-[0_0_15px_rgba(201,167,70,0.8)] z-10" data-id="element-25"></div>
                <span className="font-display text-brand-gold text-xs tracking-widest absolute -bottom-8" data-id="element-26">
                  {label}
                </span>
              </div>)}
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-16 md:mb-24" data-id="element-27">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-blue border border-brand-gold/30 rounded-xl p-8 flex flex-col h-full hover:border-brand-gold transition-colors" data-id="element-28">
              <div className="font-display text-brand-gold text-xs tracking-widest uppercase mb-4" data-id="element-29">
                {card.time}
              </div>
              <h4 className="font-display text-white text-2xl font-bold uppercase mb-4" data-id="element-30">
                {card.title}
              </h4>
              <p className="font-body text-gray-300 leading-relaxed" data-id="element-31">
                {card.body}
              </p>
            </motion.div>)}
        </div>

        {/* Callout Box */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-brand-blue border border-brand-gold/40 rounded-2xl p-8 md:p-12 text-center max-w-4xl mx-auto shadow-[0_0_40px_rgba(201,167,70,0.08)]" data-id="element-32">
          <h4 className="font-display text-brand-gold text-xl md:text-2xl font-bold uppercase tracking-widest mb-6" data-id="element-33">
            You Leave With
          </h4>
          <p className="font-body text-white text-lg md:text-2xl leading-relaxed mb-10" data-id="element-34">
            <strong className="text-brand-gold font-semibold" data-id="element-35">
              A Buy Box, the FAST Underwriting Model, and a Clear Next Move
            </strong>{' '}
            on your first commercial deal, in 90 minutes flat.
          </p>

          <GoldButton onClick={onRegisterClick} mainText="Secure Ticket Now" subText="(DON'T MISS THIS TRAINING)" className="w-full md:w-auto md:min-w-[320px] mx-auto" data-id="element-36" />
        </motion.div>
      </div>
    </section>;
}